import template from "./date.html";
import dateFormats from "../../../../server/config/dateFormats";

const DateComponent = {
  bindings: {
    name: "@",
    label: "@",
    model: "=",
    minDate: "<",
    maxDate: "<",
    required: "<",
  },
  template: template,
  controller: class DateController {
    /* @ngInject */
    constructor($scope, $rootScope) {
      this.$scope = $scope;
      this.$rootScope = $rootScope;
    }

    $onInit() {
      this.format = (
        this.$rootScope.organization.settings.dateFormat || dateFormats[0]
      )
        .replaceAll("D", "d")
        .replaceAll("Y", "y")
        .replaceAll("m", "M");

      this.options = {
        showWeeks: false,
        minDate: this.minDate,
        maxDate: this.maxDate,
      };

      this.isOpen = false;

      this.$scope.$watch(
        () => this.minDate,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.options = { showWeeks: false, minDate: this.minDate };
        }
      );
      this.$scope.$watch(
        () => this.maxDate,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.options = { showWeeks: false, maxDate: this.maxDate };
        }
      );
    }

    open() {
      this.isOpen = true;
    }
  },
};

export default DateComponent;
